import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {fromEvent, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as screenfullAsAny from 'screenfull';
import {Hotkeys} from '../../../../modules/hotkeys/hotkeys.enum';
import {HotkeysService} from '../../../../modules/hotkeys/hotkeys.service';
import {PlayerComponent} from '../../../../player/player.component';

const screenfull: any = screenfullAsAny; // Just to avoid IDE warnings

@Component({
  selector: 'gg-fullscreen-btn',
  templateUrl: './fullscreen-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullscreenBtnComponent implements OnInit {
  rootElement: HTMLElement;
  public isFullscreen$: Observable<boolean>;

  constructor(@Inject(PlayerComponent) private parent: PlayerComponent, hotkeysService: HotkeysService) {
    this.rootElement = this.parent.elementRef.nativeElement;
    this.isFullscreen$ = fromEvent(screenfull, 'change').pipe(map(() => screenfull.isFullscreen));

    hotkeysService.on(Hotkeys.toggleFullscreen).subscribe(() => this.toggleFullscreen());
  }

  ngOnInit() {
  }

  toggleFullscreen() {
    if (screenfull.enabled) {
      screenfull.toggle(this.rootElement);
    }
  }

}
